import { FC, ReactNode } from 'react';

/**
 * Lignes du bloc Tarification : libellé à gauche, montant aligné à droite, groupes
 * séparés par un filet. Reprend la présentation de l'ancien écran, dont c'était la
 * lecture de référence des utilisateurs.
 */

export const PricingGroup: FC<{ children: ReactNode }> = ({ children }) => (
  // Alternance et survol portés par le groupe, comme les listes et le bloc Détail : les
  // lignes ne sont pas cliquables, mais suivre du regard un montant sur toute la largeur
  // du bloc demande le même repère qu'ailleurs sur la page.
  <div className="border-b border-gray-100 py-2 last:border-0 [&>div:nth-child(even)]:bg-primary/[0.07] [&>div]:transition-colors [&>div:hover]:bg-primary/15">
    {children}
  </div>
);

interface PricingLineProps {
  label: string;
  value: string;
  /** Précision affichée en gris à côté du libellé, ex. le nom de la garantie. */
  context?: string;
  strong?: boolean;
}

export const PricingLine: FC<PricingLineProps> = ({ label, value, context, strong }) => (
  <div className="flex items-baseline justify-between gap-4 rounded-md px-3 py-1.5">
    <span className="min-w-0 text-sm">
      <span className={strong ? 'font-bold text-zinc-900' : 'font-semibold text-zinc-800'}>
        {label}
      </span>
      {context && <span className="ml-1.5 text-xs text-gray-400">({context})</span>}
    </span>
    <span
      className={`flex-shrink-0 text-sm ${
        strong ? 'font-bold text-zinc-900' : 'text-gray-600'
      }`}
    >
      {value}
    </span>
  </div>
);
